module.exports = __webpack_public_path__ + "img/Herodotos_Metropolitan.ff7d766c.png";